import {
  Component,
  Renderer2,
  ViewChildren,
  QueryList,
  Input,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DomController, MenuController, Platform } from "@ionic/angular";
import { Navigator } from "./navigator";
import { ConfigService } from "src/app/services/config/config.service";
import { getSidemenuSettings } from "./sidemenu-settings";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { LogoutService } from "src/app/services/logout/logout.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import {
  MenuOptionModel,
  SideMenuSettings,
} from "../../interfaces/sidemenu-interface";
import { Router } from "@angular/router";
import { EventsService } from "src/app/services/event/event.service";
import { WebcontentService } from "src/app/services/webcontent/webcontent.service";
import { sortBy } from "src/app/services/codeUtils";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { SiteLocationService } from "src/app/services/site-location/site-location.service";
import { MobileDataService } from "src/app/services/mobile-data/mobile-data.service";
import { MenuStateService } from "src/app/services/menu-state/menu-state.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { CommonAlertService } from "src/app/services/alert/alert.service";
import { BoydRewardsService } from "src/app/services/boyd-rewards/boyd-rewards.service";
import { SidemenuService } from "src/app/services/lobby/sidemenu.service";
import { ResponsibleGamingService } from "src/app/services/responsible-gaming-service/responsible-gaming.service";

@Component({
  selector: "sidemenu",
  templateUrl: "sidemenu.html",
  styleUrls: ["./sidemenu.scss"],
})
export class SidemenuComponent {
  @ViewChildren("options") optionDivs: QueryList<any>;
  @ViewChildren("optionsLevel3") optionDivsLevel3: QueryList<any>;
  @ViewChildren("headerIconR") headerIcons: QueryList<any>;
  @ViewChildren("headerIconLevel3") headerIconsLevel3: QueryList<any>;

  @Input() menuSelected: string;

  public accordianIcon: string;
  public bonusNotificationDisplayedTimes: number = 0;
  public environmentName: string;
  public externalLinks: any = [];
  public iosMenuStyle: string;
  public isAuthenticated: boolean = false;
  public isIOSApp: boolean = false;
  public isWithdrawEnable: boolean;
  public menuOptions: Array<MenuOptionModel>;
  public menuSettings: SideMenuSettings;
  public notificationCount: number;

  public socialIcons: any = [
    {
      url: "https://www.facebook.com/mohegansun",
      iconName: "logo-facebook",
    },
    {
      url: "https://twitter.com/mohegansun",
      iconName: "logo-twitter",
    },
    {
      url: "https://instagram.com/mohegansun",
      iconName: "logo-instagram",
    },
  ];

  constructor(
    public appLinks: AppLinksService,
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public config: ConfigService,
    public http: HttpClient,
    public LobbyService: LobbyService,
    public navigator: Navigator,
    public platform: Platform,
    public router: Router,
    public userSession: UserSessionService,
    public utils: UtilsService,
    public webcontentService: WebcontentService,
    public commonAlertService: CommonAlertService,
    private domCtrl: DomController,
    private logoutService: LogoutService,
    private menuCtrl: MenuController,
    private renderer: Renderer2,
    private mobileData: MobileDataService,
    private eventsService: EventsService,
    private siteLocationService: SiteLocationService,
    private boydService: BoydRewardsService,
    public menuStateService: MenuStateService,
    private sidemenuService: SidemenuService,
    private responsibleGamingProvider: ResponsibleGamingService
  ) {
    this.notificationCount = Math.floor(Math.random() * 10);


    const jsonConfig = this.config.getConfig().SIDEMENU_SOCIAL_ARRAY;
    try {
      this.socialIcons = JSON.parse(jsonConfig) ?? this.socialIcons;
    } catch (error) {
      console.error('Error parsing JSON:', error);
      this.socialIcons = [];
    }


    this.isIOSApp = this.platform.is("capacitor") && this.platform.is("ios");
  }

  ngOnInit() {

    this.menuSettings = getSidemenuSettings();
    //this.userSession.isAuthenticated().then((res)=> this.isAuthenticated = res);
    this.checkAuth();
    this.eventsService.subscribe("event:config:reload", () => {
      this.config.isLoaded().then(() => {
        this.getExternalLinks();
      });
    });

    this.getExternalLinks();

    this.userSession.getUserStatus().subscribe((userStatus) => {
      if (userStatus) this.isAuthenticated = true;
      else this.isAuthenticated = false;
    });
    this.sidemenuService.getSidemenuData(this.menuSelected);

    this.sidemenuService.getMenuData().subscribe(data => {
      this.menuOptions = data;
    })


  }

  public getExternalLinks() {
    this.externalLinks = this.config
      .getExternalLinks()
      .payload.filter((link) => link.isHamburgerMenu == "1")
      .sort(sortBy("lobbyNavBarPosition"));
  }

  checkAuth() {
    this.userSession.isAuthenticated().then((isAuthenticated) => {
      if (isAuthenticated) {
        this.isAuthenticated = isAuthenticated;
      } else {
        this.isAuthenticated = false;
      }
    });
  }

  public select(option: MenuOptionModel) {
    if (!!option.requiresQualification) return;
    if (option.component == "add_funds") return this.onDeposit();
    return this.navigateToAPage(option.component, option, this.menuSelected == "right" ? "main-menu" : "left-menu");
  }

  public navigateToAPage(pageName: string, params: any, menuSide): any {
    if (!!params && params.loyaltyCardCheck) {
      this.closeSidemenu(menuSide);
      this.boydService.checkConnectionToBoydCard().subscribe((res) => {
        if (!res) {
          return this.navigator.navigateTo("EnrollBoydRewardsComponent");
        } else {
          return this.navigator.navigateTo(pageName, {}, params, menuSide);
        }
      }).unsubscribe();
    } else if (pageName === "main-menu") {
      this.menuStateService.openSidemenu("main-menu");
    } else {
      this.closeSidemenu(menuSide);
      return this.navigator.navigateTo(pageName, {}, params, menuSide);
    }
  }

  public openMainMenu(pageName: string, params: any, menuSide) {
    this.menuCtrl.open(pageName);
  }

  public closeSidemenu(menuSide: string) {
    return this.menuCtrl.close(menuSide);
  }

  public openWebview(link: any) {
    if (link === "promos") {
      let obj = {
        action_param: "promotions",
        action_type: "externalpageload",
        name: "Promotions",
      };

      this.mobileData.sendExternalSelection(obj.name);
      this.eventsService.publish("searchbar:keyword:click", obj);
    } else {
      const obj = {
        action_param: "",
        action_type: "",
        name: "",
      };

      this.mobileData.sendExternalSelection("null");
      this.eventsService.publish("searchbar:keyword:click", obj);
    }

    this.closeSidemenu("secondary-menu");
    this.webcontentService.updateExternalLink(link);
    this.eventsService.publish("event:reload:externallinks");
    this.navigator.toWebview(false, link);
  }

  public openExternalLink(link: any) {
    const obj = {
      action_param: "",
      action_type: "",
      name: "",
    };

    this.mobileData.sendExternalSelection("null");
    this.eventsService.publish("searchbar:keyword:click", obj);
    this.closeSidemenu("secondary-menu");
    return this.appLinks.openExternalPage(link);
  }

  private onDeposit(): any {
    this.closeSidemenu("main-menu");
    return this.cashierService
      .getActiveTypesCategories({ include_types: false })
      .subscribe(
        (response: any) => {
          if (response) {
            const data = response.payload.filter(
              (item) => item.is_default == true
            );
            // const lastDeposit = data.length > 0 ? data[0].code : null;
            // const pageToRedirect =
            //   this.cashierContentService.getVendorPage(lastDeposit);

            // !!pageToRedirect
            //   ? this.navigator.navigateTo(
            //     pageToRedirect,
            //     {},
            //     { navigateBackPage: "sidemenu" }
            //   )
            // :
            // this.navigator.navigateTo("DepositMainComponent", {
            //   navigateBackPage: "sidemenu",
            // });




            this.responsibleGamingProvider.getAllPendingLimit().subscribe(
              (response: any) => {
                if (response.payload.length !== 0) {
                  this.navigator.navigateTo('LimitConfirmationComponent', { forceModal: true },{ callBackFn: () => { this.navigator.navigateTo("DepositMainComponent",{
                    navigateBackPage: "sidemenu",
                  }); }});
                } else {
                  this.navigator.navigateTo("DepositMainComponent", {
                    navigateBackPage: "sidemenu",
                  });
                  console.log('No Pending Limit for User')
                }
              },
              (error) => {
                this.navigator.navigateTo("DepositMainComponent", {
                    navigateBackPage: "sidemenu",
                  });
                console.log('Error:  Pending Limit')
              }
            );
          }
        },
        (error) => {
          this.navigator.navigateTo("DepositMainComponent", {
            navigateBackPage: "sidemenu",
          });
        }
      );
  }

  public toggleItemOptions(
    optionsDivElement: any,
    arrowIcon: any,
    itemsCount: number,
    level: number
  ): void {
    if (this.menuSettings.accordionMode) {
      this.collapseAllOptionsExceptToogdled(optionsDivElement, level);
      this.resetAllIconsExceptToggled(arrowIcon.el, level);
    }
    this.toggleOptionSubItems(
      optionsDivElement,
      this.itemHeight + 1,
      itemsCount
    );
    this.toggleOptionIcon(arrowIcon.el, level);
  }

  private collapseAllOptionsExceptToogdled(
    selectedOptionsContainer,
    level
  ): void {
    if (level == 2) {
      this.optionDivs.forEach((optionDiv) => {
        this.domCtrl.read(() => {
          let optionElement = optionDiv.nativeElement;
          if (
            optionElement.id !== selectedOptionsContainer.id &&
            this.subItemsAreExpanded(optionElement)
          ) {
            this.hideSubItems(optionElement);
          }
        });
      });

      return;
    }

    this.optionDivsLevel3.forEach((optionDiv) => {
      this.domCtrl.read(() => {
        let optionElement = optionDiv.nativeElement;
        if (
          optionElement.id !== selectedOptionsContainer.id &&
          this.subItemsAreExpanded(optionElement)
        ) {
          this.hideSubItems(optionElement);
        }
      });
    });

    return;
  }

  // Reset the arrow icon of all the options except the selected option
  private resetAllIconsExceptToggled(
    selectedArrowIcon: any,
    level: number
  ): void {
    if (level == 2) {
      this.headerIcons.forEach((headerIcon) => {
        this.domCtrl.read(() => {
          let iconElement = headerIcon.el;
          if (
            iconElement.id !== selectedArrowIcon.id &&
            this.iconIsRotated(iconElement)
          ) {
            this.resetExpandCollapseIcon(iconElement);
          }
        });
      });
      return;
    }

    this.headerIconsLevel3.forEach((headerIcon) => {
      this.domCtrl.read(() => {
        let iconElement = headerIcon.el;
        if (
          iconElement.id !== selectedArrowIcon.id &&
          this.iconIsExpanded(iconElement)
        ) {
          this.resetIcon(iconElement);
        }
      });
    });
    return;
  }

  private toggleOptionSubItems(
    optionsContainer: any,
    elementHeight: number,
    itemsCount: number
  ) {
    this.domCtrl.write(() => {
      this.subItemsAreExpanded(optionsContainer) ? shrink() : expand();
    });

    let shrink = () => {
      this.renderer.setStyle(optionsContainer, "height", "0px");
      this.renderer.setStyle(optionsContainer, "box-shadow", `none`);
      this.renderer.setStyle(optionsContainer, "padding-top", "0px");
      this.renderer.setStyle(optionsContainer, "padding-bottom", "0px");
    };
    let expand = () => {
      //this.renderer.setStyle(optionsContainer, 'height', `${(elementHeight * itemsCount)}px`);
      this.renderer.setStyle(optionsContainer, "height", `auto`);
    };
  }

  public get itemHeight(): number {
    if (this.platform.is("ios")) return this.menuSettings.itemHeight.ios;
    if (this.platform.is("desktop")) return this.menuSettings.itemHeight.wp;
    return this.menuSettings.itemHeight.md;
  }

  // Return true if sub items are expanded
  private subItemsAreExpanded(element: any): boolean {
    return element.style.height !== "" && element.style.height !== "0px";
  }

  // Return true if the icon is rotated
  private iconIsRotated(element: any): boolean {
    return element.classList.contains("rotate");
  }

  private iconIsExpanded(element: any): boolean {
    return element.classList.contains("switch");
  }

  // Toggle the arrow icon of the selected option
  private toggleOptionIcon(arrowIcon: any, level: number): void {
    if (level == 3) {
      this.domCtrl.write(() => {
        if (this.iconIsExpanded(arrowIcon)) {
          this.renderer.setProperty(arrowIcon, "name", "add-outline");
          this.renderer.removeClass(arrowIcon, "switch");
        } else {
          this.renderer.setProperty(arrowIcon, "name", "remove-outline");
          this.renderer.addClass(arrowIcon, "switch");
        }
      });
    } else {
      this.domCtrl.write(() => {
        this.iconIsRotated(arrowIcon)
          ? this.renderer.removeClass(arrowIcon, "rotate")
          : this.renderer.addClass(arrowIcon, "rotate");
      });
    }
  }

  // Collapse the sub items of the selected option
  private hideSubItems(optionsContainer: any): void {
    this.domCtrl.write(() => {
      this.renderer.setStyle(optionsContainer, "height", "0px");
      this.renderer.setStyle(optionsContainer, "box-shadow", "none");
    });
  }

  // Reset the arrow icon of the selected option
  private resetIcon(arrowIcon: any): void {
    this.domCtrl.write(() => {
      if (this.iconIsExpanded(arrowIcon)) {
        this.renderer.setProperty(arrowIcon, "name", "add-outline");
        this.renderer.removeClass(arrowIcon, "switch");
      } else {
        this.renderer.setProperty(arrowIcon, "name", "remove-outline");
        this.renderer.addClass(arrowIcon, "switch");
      }
    });
  }

  // Reset the arrow icon of the selected option
  private resetExpandCollapseIcon(arrowIcon: any): void {
    this.domCtrl.write(() => {
      this.renderer.removeClass(arrowIcon, "rotate");
    });
  }

  public onLogout() {
    this.menuCtrl.close();
    return this.logoutService.onLogout();
  }

  public execute(method) {
    return this[method]();
  }

  public onSocialIconClick(link) {
    return this.appLinks.openExternalPage(link);
  }

  onBoydRewardsWebsite() {
    this.appLinks.openExternalPage(
      this.config.getConfig()["FEATURE_BOYD_REWARDS_URL"]
    );
  }

  public changeState(url, stateCode) {
    this.menuCtrl.close();

    if (this.isAuthenticated) {
      this.commonAlertService.changeJurisdiction(() =>
        this.siteLocationService.changeState(url, stateCode)
      );
    } else {
      this.siteLocationService.changeState(url, stateCode);
    }
  }
  toPascalCase(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w|\s+|[-_])/g, function(match) {
        return match.toUpperCase();
      });
  }
}
